<template>
  <div class="page">
    <v-container fluid>
      <avp-breadcrumbs></avp-breadcrumbs>
      <v-form ref="form">
        <v-row class="d-flex justify-center mt-3">
          <avp-date-picker
            v-model="form.filters.dataInicioTentativaLogin"
            label="Data início da tentativa de login"
            removeIcon
            cols="auto"
            :dataEdicao="form.filters.dataInicioTentativaLogin"
          ></avp-date-picker>
          <avp-date-picker
            v-model="form.filters.dataFimTentativaLogin"
            label="Data fim da tentativa de login"
            removeIcon
            cols="auto"
            :dataEdicao="form.filters.dataFimTentativaLogin"
          ></avp-date-picker>
          <avp-select-ano-semestre
            :cols="4"
            v-model="form.filters"
            :sufix="'da Comprovação'"
            required
            all
          ></avp-select-ano-semestre>
        </v-row>
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              label="Nome"
              v-model="form.filters.nome"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              label="CPF"
              v-mask="'###########'"
              v-model="form.filters.cpf"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <avp-switch-button
            v-model="form.filters.analitico"
            :cols="2"
            label="Tipo de Relatório"
            labelChecked="Analítico"
            labelUnchecked="Sintético"
          ></avp-switch-button>
        </v-row>
        <div class="d-flex justify-center"></div>
        <div class="text-center">
          <v-col cols="12">
            <avp-tooltip
              :text="'Buscar'"
              :icon="'mdi-magnify'"
              @click="buscarRelatorios()"
            ></avp-tooltip>
            <avp-tooltip
              :text="'Limpar'"
              :icon="'mdi-eraser'"
              @click="resetForm()"
            ></avp-tooltip>
          </v-col>
        </div>
      </v-form>
      <!-- Se o resultado da consulta de relatório for analítico -->
      <v-data-table
        v-if="form.mostrarAnalitico"
        class="mt-5 printable"
        :headers="getFilteredHeader(headersAnalitico)"
        :items="form.lists.listRelatorios"
        :items-per-page="form.itemsPerPage"
        :footer-props="$footerProps"
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nomeProfissional }}
        </template>
        <template v-slot:[`item.cpf`]="{ item }">
          <div class="hide-report">
            {{ item.cpfComMascara }}
          </div>
          <div class="report">
            {{ $formatCpf(item.cpfSemMascara) }}
          </div>
        </template>
      </v-data-table>
      <!-- Se o resultado da consulta de relatório for sintético -->
      <v-data-table
        v-else
        class="mt-5 printable"
        :headers="getFilteredHeader(headersSintetico)"
        :items="form.lists.listRelatorios"
        :items-per-page="form.itemsPerPage"
        :footer-props="$footerProps"
      >
        <template v-slot:[`item.nome`]="{ item }">
          {{ item.nomeProfissional }}
        </template>
        <template v-slot:[`item.cpf`]="{ item }">
          <div class="hide-report">
            {{ item.cpfComMascara }}
          </div>
          <div class="report">
            {{ $formatCpf(item.cpfSemMascara) }}
          </div>
        </template>
      </v-data-table>
      <avp-buttons
        v-if="form.lists.listRelatorios.length"
        :actionText="'Imprimir'"
        :actionIcon="'mdi-printer'"
        :cancelText="'Baixar CSV'"
        :cancelIcon="'mdi-file'"
        @click="imprimirRelatorio()"
        @cancel="baixarCSVRelatorio()"
      ></avp-buttons>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "ListarRelatoriosProfissionalSemBeneficioView",
  data: () => ({
    onReport: false,
    form: {
      filters: {
        dataInicioTentativaLogin: null,
        dataFimTentativaLogin: null,
        ano: null,
        semestre: null,
        nome: null,
        cpf: null,
        analitico: true,
      },
      lists: {
        listRelatorios: [],
      },
      itemsPerPage: 10,
      geradorRelatorio: null,
      horaDaGeracao: null,
      totalAcoesCapacitacao: 0,
      mostrarAnalitico: true,
    },
    headersAnalitico: [
      { text: "CPF", align: "center", value: "cpf" },
      { text: "Nome do Profissional", align: "center", value: "nome" },
      { text: "Lotação", align: "center", value: "lotacao" },
      { text: "Motivo", align: "center", value: "motivo" },
      {
        text: "Data de tentativa de login",
        align: "center",
        value: "dataTentativaLogin",
      },
      { text: "Ano", align: "center", value: "ano", onlyReport: true },
      {
        text: "Semestre",
        align: "center",
        value: "semestre",
        onlyReport: true,
      },
    ],
    headersSintetico: [
      {
        text: "Nome do Profissional",
        align: "center",
        value: "nome",
        onlyReport: true,
      },
      { text: "CPF", align: "center", value: "cpf", onlyReport: true },
      { text: "Ano", align: "center", value: "ano" },
      { text: "Semestre", align: "center", value: "semestre" },
      { text: "CPF", align: "center", value: "cpf", onlyView: true },
      {
        text: "Nome do Profissional",
        align: "center",
        value: "nome",
        onlyView: true,
      },
      {
        text: "Quantidade de Tentativa",
        align: "center",
        value: "quantidadeTentativasLoginEdicao",
      },
    ],
  }),
  computed: {
    isAnalitico() {
      return this.form.filters.analitico;
    },
  },
  methods: {
    resetForm() {
      this.$resetForm();
      this.form.filters.dataInicioTentativaLogin = null;
      this.form.filters.dataFimTentativaLogin = null;
      this.form.lists.listRelatorios = [];
    },
    getFilteredHeader(headers) {
      return headers.filter((header) => {
        if (header.onlyView) return !this.onReport;
        if (header.onlyReport) return this.onReport;
        return true;
      });
    },
    buscarRelatorios() {
      if (this.$validarFormulario()) {
        const preparedRequest = JSON.parse(JSON.stringify((this.form.filters)));
        if (preparedRequest.dataFimTentativaLogin) {
          preparedRequest.dataFimTentativaLogin =
            this.$formatarDateParaEnviar(preparedRequest.dataFimTentativaLogin, "23:59:59")
        }
        const buscarRelatorio = (params) => {
          return this.isAnalitico
            ? this.$obterRelatorioProfissionalSemBeneficio(params)
            : this.$obterRelatorioProfissionalSemBeneficioSintetico(params);
        };
        buscarRelatorio(this.$montarParamsFilters(preparedRequest)).then(
          ({ data }) => {
            this.form.mostrarAnalitico = this.isAnalitico;
            this.form.geradorRelatorio = data.relatorio.geradorRelatorio;
            this.form.horaDaGeracao = data.relatorio.horaDaGeracao;
            this.form.totalAcoesCapacitacao = data.relatorio.totalTentativasAcesso;
            this.form.lists.listRelatorios = data.relatorio.profissionais;
          }
        );
      }
    },
    imprimirRelatorio() {
      this.onReport = true;
      this.form.itemsPerPage = -1;
      const importCSStoPrint = () =>
        import("!raw-loader!sass-loader!/src/assets/styles/_print.scss");
      importCSStoPrint().then((scss) => {
        let newWindow = window.open();
        newWindow.document.write(`
        <div class="report">
          <style>${scss.default}</style>
          <div class="report-header-title">
            <h1>Relatório de Profissionais Sem Benefício</h1>
          </div>
          ${document.querySelector(".printable").outerHTML}
          <div class="report-header-title">
            <h3>Quantidade Total de Profissionais Sem Benefício: ${
              this.form.totalAcoesCapacitacao
            }</h3>
            <h3>Nome do usuário de Geração: ${this.form.geradorRelatorio}</h3>
            <h3>Data/Hora da Geração: ${this.form.horaDaGeracao}</h3>
          </div>
        </div>`);
        newWindow.print();
        newWindow.close();
        this.form.itemsPerPage = 10;
        this.onReport = false;
      });
    },
    baixarCSVRelatorio() {
      const baixarRelatorio = (params) => {
        return this.isAnalitico
          ? this.$obterRelatorioCSVProfissionalSemBeneficio(params)
          : this.$obterRelatorioCSVProfissionalSemBeneficioSintetico(params);
      };
      baixarRelatorio(this.$montarParamsFilters(this.form.filters)).then(
        ({ data }) => {
          const getEncodeData = () => encodeURIComponent(`\uFEFF${data}`)
          const a = window.document.createElement("a");
          a.setAttribute("href", `data:text/csv; charset=utf-8,${getEncodeData()}`);
          a.setAttribute("download", `relatorio-profissional-sem-beneficio-${Date.now()}.csv`);
          a.click();
          this.$notifySuccess("Relatório baixado com sucesso!");
        }
      );
    },
  },
};
</script>